import { css } from "emotion";
import { connect } from "react-redux";

const Button = ({
  type = "secondary",
  buttonType = "button",
  size = "default",
  link,
  onClick = _ => {},
  event,
  tourTheme = false,
  order,
  children,
  ariaLabel,
  fullWidth = false,
  height = 40,
  form,
  dataCY = "default"
}) => {
  let theme =
    event && event.data && event.data.theme ? event.data.theme : false;
  theme = tourTheme ? tourTheme : theme;
  const buttonDefaults = {
    width: fullWidth ? "100%" : "auto",
    display: "flex",
    justifyContent: "center",
    verticalAlign: "top",
    fontWeight: 600,
    fontSize: size === "small" ? 14 : 16,
    borderRadius: 4,
    paddingLeft: 16,
    paddingRight: 16,
    height: size === "small" ? 36 : height,
    paddingTop: link ? 2 : 0,
    paddingBottom: 0,
    lineHeight: 2.1,
    textDecoration: "none !important",
    border: "solid 1px transparent"
  };

  const styles = {
    primary: {
      backgroundColor:
        theme && theme.primaryColor ? theme.primaryColor : "#6621c0",
      border: "solid 1px transparent",
      color: theme && theme.primaryTextColor ? theme.primaryTextColor : "#fff",
      "&:hover": {
        backgroundColor:
          theme && theme.primaryTextColor ? theme.primaryTextColor : "#fff",
        border:
          theme && theme.primaryColor
            ? `solid 1px ${theme.primaryColor}`
            : "solid 1px #2074d9",
        color: theme && theme.primaryColor ? `${theme.primaryColor}` : "#2074d9"
      }
    },
    secondary: {
      backgroundColor: "transparent",
      border:
        theme && theme.primaryColor
          ? `solid 1px ${theme.primaryColor}`
          : "solid 1px #6621c0",
      color: theme && theme.primaryColor ? `${theme.primaryColor}` : "#6621c0",
      "&:hover": {
        backgroundColor:
          theme && theme.primaryColor ? theme.primaryColor : "#6621c0",
        border: "solid 1px transparent",
        color: theme && theme.primaryTextColor ? theme.primaryTextColor : "#fff"
      }
    },
    tertiary: {
      backgroundColor: "transparent",
      border: "solid 1px #788391",
      color: "#323232",
      "&:hover": {
        backgroundColor: "#788391",
        border: "solid 1px transparent",
        color: "#fff"
      }
    }
  };

  return link ? (
    <a
      className={css`
        ${buttonDefaults};
        ${styles[type]}
      `}
      href={link}
    >
      {children}
    </a>
  ) : (
    <button
      className={css`
        ${buttonDefaults};
        ${styles[type]}
      `}
      type={buttonType}
      onClick={onClick}
      aria-label={ariaLabel}
      formId={form}
      data-cy={dataCY}
    >
      {children}
    </button>
  );
};

export default connect((state, ownProps) => ({
  event: state.event,
  order: state.order
}))(Button);
